import { UserProductGroup } from '~/Api/User/ProductGroup';
import config from '~/config';
import { State as ProductPriceState } from '~/ProductPrice';
import buildProductGroupUrl from '~/Router/buildProductGroupUrl';

export default function buildGroupInitialUrl(
	group: UserProductGroup,
	state: { productPrice: ProductPriceState }
): { pathname: string; search: string } {
	const priceType =
		group.isProductList() && group.systemModule === null ? state.productPrice.priceTypePreference.load() : undefined;
	return buildProductGroupUrl(group.id, priceType, null, config.product.defaultPriceCurrency);
}
